import React, {useEffect} from 'react'
import { getNotifs, setNotifsImportant} from "../store/actions/notifAction"
import { useDispatch, useSelector } from 'react-redux'

export default () => {
    const dispatch = useDispatch()
    const {notifs, loading, item} = useSelector(state => state.notifReducer)
   
    useEffect(() => {
        dispatch(getNotifs())
    }, [dispatch])
    
    function typeMsg(msg){
        let a = msg.split("##")
        return a[2]
    }

    function summaryMsg(msg){
        let a = msg.split("##")
        return a[10]
    }

    function addImportant(item){
        dispatch(setNotifsImportant(item))
        console.log(item,"---add important")
    }

    return (
        <>
            <h2>Space Report</h2>
            <div id="link">
                <br/>
                <h4>Your Link</h4>
                <a href={item}>{item}</a>
                <br/>
                <br/>
            </div> 
            
            {
                loading ? <p>Loading..</p> : (
                <div style={{display: "flex", flexWrap: "wrap"}}>
                    { 
                    notifs.map((item, idx)=> (
                        <div key={idx} id="card-notif">
                            <button onClick={()=> addImportant(item.messageURL)} id="btn-notif">Get Link</button>
                            <p>ID: {item.messageID}</p>
                            <p>{typeMsg(item.messageBody)}</p>
                            <p>{summaryMsg(item.messageBody)}</p>
                        </div>
                        )
                    )
                    }
                    
                </div>
                )
            }
           
        </>
    )
}